import { Grid, Stack } from '@mui/material';
import { Box } from '@mui/system';
import axios from '../../common/api/axiosConfig';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorAlertNotification } from '../../common/ErrorHandling/ErrorAlertNotification';
import { styles } from '../../style/style';
import { ChargeToBacLabel, ChargeToBacText, ChargeToBfc, ClearButton, EndUserFan, ModelYear, OrderSummaryAppName, PrimaryFanLabel, PrimaryFanText, SearchButton, ShipToBac, ShipToBacLabel } from './OrderSummaryComponents';
import { setOrderSummaryDataList, setSearchFieldList } from './orderSummarySlice';
import OrderSummaryTable from './OrderSummaryTable';
import { useIntl } from 'react-intl';
import log from '../../common/components/Logger'


export default function OrderSummary() {
    const login = useSelector((state) => state.login.data.payload.login);

    if (!login) {
        window.location.href = '/home';
    }



    const intl = useIntl();
    const dispatch = useDispatch();
    const [primaryFan, setPrimaryFan] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.primaryFan));
    const [bacNumber, setBacNumber] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.chargeToBac));
    const [endUserFan, setEndUserFan] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.endUserFan));
    const [chargeBfc, setChargeBfc] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.chargeToBfc));
    const [shipBac, setShipBac] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.shipToBac));
    const [chargeToBac, setChargeToBac] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.chargeToBac));
    const [selectedYear, setSelectedYear] = useState(useSelector((state) => state.searchFieldList.searchFieldData.payload.modelYear));
    const [error, setError] = useState(true);
    const [cleared, setCleared] = useState(false);
    const [modelYear, setModelYear] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [invalidChargeToBacMessage, setInvalidChargeToBacMessage] = useState("");
    const [invalidChargeToBfcMessage, setInvalidChargeToBfcMessage] = useState("");
    const [invalidEndUserFanMessage, setInvalidEndUserFanMessage] = useState("");
    const [invalidPrimaryFanMessage, setInvalidPrimaryFanMessage] = useState("");
    const [invalidShipToBacMessage, setInvalidShipToBacMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [modelYearRequired, setModelYearRequired] = useState("");
    const ApiList = useSelector((state) => state.apiList.apiList);
    const [open, setOpen] = useState(false);
    const [errorType, setErrorType] = useState("");
    const [loading, setLoading] = useState(false);
    const dataListItem = useSelector((state) => state.searchFieldList.orderSummaryData.payload);
    const userDetails = useSelector((state) => state.user.data.payload);
    const childBacs = useSelector((state) => state.childBac?.data?.childBacs || []);
    const idToken = localStorage.getItem("idToken")
    const [gdlError, setGdlError] = useState("");
    const [selectedShipBacs, setSelectedShipBacs] = useState(
        typeof shipBac === 'string' && shipBac !== '' ? shipBac.split(',').map((value) => value.trim()).filter((value) => value !== '') : []
    );
    const [selectedChargeToBacs, setSelectedChargeToBacs] = useState(
        typeof chargeToBac === 'string' && chargeToBac !== '' ? chargeToBac.split(',').map((value) => value.trim()).filter((value) => value !== '') : []
    );
    const normalizeUniqueBacs = (values) => [...new Set((values || []).map((value) => String(value).trim()).filter((value) => value !== ''))];
    const isUpfitter = String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER';
    const isFleetDealer = String(userDetails?.partnerType || '').toUpperCase() === 'FLEETDEALER';
    const shipToBacOptions = normalizeUniqueBacs([userDetails?.bac, ...childBacs]);
    // For FleetDealer, only use childBacs
    const chargeToBacOptions = isFleetDealer ? normalizeUniqueBacs([...childBacs]) : normalizeUniqueBacs([userDetails?.bac, ...childBacs]);

    const lockShipToBacSelection = isUpfitter && childBacs.length === 0;
    const requiresShipToBacSelection = isUpfitter && shipToBacOptions.length > 1;
    const lockChargeToBacSelection = false;
    const requiresChargeToBacSelection = false; // Charge-to BAC is optional since primary FAN is pre-selected for Fleet Dealers
    const url = ApiList.getsearchinputbyrole;
    const [userData, setUserData] = useState({
        user: {
            userId: userDetails.userId,
            partnerType: userDetails.partnerType,
            preferredLanguage: userDetails.preferredLanguage,
            bac: userDetails.bac,
            primaryFan: userDetails.primaryFAN
        }
    });

    const [apiConfig, setApiConfig] = useState({
        headers: {
            method: 'POST',
            'Content-Type': 'application/json'
        }
    });


    useEffect(() => {
        axios.post(url, userData, apiConfig)
            .then((response) => {
                if (!cleared) {
                }
                if (response.status === 200) {
                    log.info(`fos_ui_log: OrderSummary():getsearchinputbyrole ${response.data.statusMessage}`)
                    setError(false)
                    // For upfitters: Ship-To BAC is fixed, Charge-To BAC is blank/editable
                    if (String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER') {
                        const defaultShipToBac = normalizeUniqueBacs([response.data.bac, userDetails?.bac, ...shipToBacOptions])[0] || '';
                        if (shipToBacOptions.length > 1) {
                            const initialSelection = defaultShipToBac !== '' ? [defaultShipToBac] : [];
                            setShipBac(initialSelection.join(','));
                            setSelectedShipBacs(initialSelection);
                            document.getElementById("shipToBacText").style.display = 'block';
                            document.getElementById("shipToBacLabel").style.display = 'none';
                        } else {
                            const fixedSelection = defaultShipToBac !== '' ? [defaultShipToBac] : [];
                            setShipBac(fixedSelection.join(','));
                            setSelectedShipBacs(fixedSelection);
                            document.getElementById("shipToBacLabel").style.display = 'block';
                            document.getElementById("shipToBacText").style.display = 'none';
                        }
                        if (!bacNumber) {
                            setBacNumber('');
                        }
                        document.getElementById("chargeToBacGridText").style.display = 'block';
                    } else if (String(userDetails?.partnerType || '').toUpperCase() === 'FLEETDEALER') {
                        // For FLEETDEALER: Charge-To BAC dropdown
                        if (chargeToBacOptions.length >= 1) {
                            // Show dropdown with child BACs
                            if (!bacNumber) {
                                setSelectedChargeToBacs([]);
                            }
                            document.getElementById("chargeToBacGridText").style.display = 'block';
                            document.getElementById("chargeToBacGridLabel").style.display = 'none';
                        } else {
                            // No child BACs available - show empty text field
                            if (!bacNumber) {
                                setSelectedChargeToBacs([]);
                            }
                            document.getElementById("chargeToBacGridText").style.display = 'block';
                            document.getElementById("chargeToBacGridLabel").style.display = 'none';
                        }
                        // Ship-To BAC is editable for FLEETDEALER
                        document.getElementById("shipToBacLabel").style.display = 'none';
                        document.getElementById("shipToBacText").style.display = 'block';
                    } else {
                        // For non-upfitters and non-FLEETDEALER: use standard bacFixed logic
                        if (response.data.bacFixed === true) {
                            document.getElementById("chargeToBacGridLabel").style.display = 'block';
                            setBacNumber(response.data.bac);
                        } else {
                            document.getElementById("chargeToBacGridText").style.display = 'block';
                        }
                        // Ship-To BAC is editable for non-upfitters
                        document.getElementById("shipToBacLabel").style.display = 'none';
                        document.getElementById("shipToBacText").style.display = 'block';
                    }

                    if (response.data.primaryFanFixed === true) {
                        document.getElementById("primaryFanLabel").style.display = 'block';
                        setPrimaryFan(response.data.primaryFan);
                    } else {
                        document.getElementById("primaryFanText").style.display = 'block';
                    }

                    if (response.data.hideEndUserFan === false) {
                        document.getElementById("endUserFanGrid").style.display = 'block';
                    }
                }
            })
            .catch((error) => {
                if (error.response.status === 404) {
                    document.getElementById("chargeToBacGridText").style.display = 'block';
                    document.getElementById("shipToBacLabel").style.display = 'none';
                    document.getElementById("shipToBacText").style.display = 'block';
                    document.getElementById("primaryFanText").style.display = 'block';
                    document.getElementById("endUserFanGrid").style.display = 'block';
                    setError(true)
                    log.error(`fos_ui_log: OrderSummary():getsearchinputbyrole ${error.message}`)
                }
                else {
                    setError(true);
                    log.error(`fos_ui_log: OrderSummary():getsearchinputbyrole ${error.message}`)
                    setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
                }
            })
    }, [url, userData, apiConfig, userDetails.partnerType, intl, shipToBacOptions.length, childBacs.length]);

    useEffect(() => {
        if (userDetails.partnerType !== 'GM_Corporate' && userDetails.partnerType !== 'GM_Wholesale' && userDetails.partnerType !== 'FLEET' && userDetails.partnerType !== 'FLEETDEALER') {
            axios.post(ApiList.getDealerInfo, userData, apiConfig)
                .then((response) => {
                    if (response.data.statusMessage !== null && response.data.statusMessage !== "Success") {
                        setGdlError(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                        log.info(`fos_ui_log: OrderSummary():getdealerinfo: ${response.data.statusMessage}`)
                    }
                    log.info(`fos_ui_log: OrderSummary():getdealerinfo: ${response.data.statusMessage}`)
                    return (response.data.userProfile)
                })
                .then((dealer) => {
                    setCompanyName("for " + dealer.dealerList[0].companyName)
                }).catch(err => log.error(`fos_ui_log: OrderSummary():getdealerinfo: ${err}`))
        } else if (userDetails.partnerType === 'FLEET' || userDetails.partnerType === 'FLEETDEALER') {
            setCompanyName("for " + userDetails.name)
        }
        else {
            setCompanyName("")
        }
    }, []);

    useEffect(() => {
        axios.get(ApiList.getModelYear, apiConfig)
            .then((res) => {
                setModelYear(res.data.activeYears)
                log.info(`fos_ui_log: OrderSummary():getmodelyear: ${res.data.statusMessage}`)
                if (selectedYear == "") { 
                    setSelectedYear([res.data.activeYears[res.data.activeYears.length - 1]])
                }
            }).catch(err => log.error(`fos_ui_log: OrderSummary():getmodelyear: ${err}`))
    }, []);


    const formValidation = async () => {
        const url = ApiList.formValidation;
        setLoading(true);
        const formData = {
            orderSummarySearch: {
                primaryFleetAccountNumber: primaryFan,
                endUserFleetAccountNumber: endUserFan,
                chargeToBac: bacNumber,
                chargeToBfc: chargeBfc,
                shipToBac: shipBac,
                modelYear: selectedYear.toString(),
                partnerType: userDetails.partnerType
            }
        }

        const response = await axios
            .post(url, formData, apiConfig)
            .then((res => {
                log.info(`fos_ui_log: OrderSummary():formValidation: Success data fetched`)
                dispatch(setOrderSummaryDataList(res.data.allocationGroupList));
                setLoading(false);
                if (res.data.statusMessage !== null) {
                    setStatusMessage(intl.formatMessage({ id: res.data.statusMessage, defaultMessage: "Error Found" }))
                    log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.statusMessage}`)
                    setErrorType('error')
                    setInvalidChargeToBacMessage("");
                    setInvalidChargeToBfcMessage("");
                    setInvalidEndUserFanMessage("");
                    setInvalidPrimaryFanMessage("");
                    setInvalidShipToBacMessage("");
                    setOpen(true);
                } else {
                    setStatusMessage("")
                    if (res.data.invalidChargeToBacMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidChargeToBacMessage} : ${bacNumber}`)
                        setInvalidChargeToBacMessage(intl.formatMessage({ id: res.data.invalidChargeToBacMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidChargeToBacMessage("")
                    }
                    if (res.data.invalidChargeToBfcMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidChargeToBfcMessage} : ${chargeBfc}`)
                        setInvalidChargeToBfcMessage(intl.formatMessage({ id: res.data.invalidChargeToBfcMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidChargeToBfcMessage("")
                    }
                    if (res.data.invalidEndUserFanMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidEndUserFanMessage} : ${endUserFan}`)
                        setInvalidEndUserFanMessage(intl.formatMessage({ id: res.data.invalidEndUserFanMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidEndUserFanMessage("")
                    }
                    if (res.data.invalidPrimaryFanMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidPrimaryFanMessage} : ${primaryFan}`)
                        setInvalidPrimaryFanMessage(intl.formatMessage({ id: res.data.invalidPrimaryFanMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidPrimaryFanMessage("")
                    }
                    if (res.data.invalidShipToBacMessage !== null) {
                        log.info(`fos_ui_log: OrderSummary():formValidation: ${res.data.invalidShipToBacMessage} : ${shipBac}`)
                        setInvalidShipToBacMessage(intl.formatMessage({ id: res.data.invalidShipToBacMessage, defaultMessage: "Error Found" }));
                        setErrorType('error')
                        setOpen(true);
                    } else {
                        setInvalidShipToBacMessage("");
                    }
                }
            }))
            .catch((error) => {
                setLoading(false);
                setOpen(true);
                setErrorType('error')
                log.error(`fos_ui_log: OrderSummary():formValidation: ${error.message}`)
                setStatusMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
            })
    }


    /*  let gridSize;
     if (userData.partnerType === "FLEET") {
         gridSize = 4;
     } else {
         gridSize = 3;
     } */

    const SubmitHandler = (e) => {
        e.preventDefault()

        // Reset prior validation/snackbar messages so only current validation feedback is shown.
        setStatusMessage('');
        setInvalidChargeToBacMessage('');
        setInvalidChargeToBfcMessage('');
        setInvalidEndUserFanMessage('');
        setInvalidPrimaryFanMessage('');
        setInvalidShipToBacMessage('');

        if (requiresShipToBacSelection && selectedShipBacs.length === 0) {
            setInvalidShipToBacMessage(
                intl.formatMessage({
                    id: 'ordersummarycomponents.shiptobacrequired',
                    defaultMessage: 'Select at least one Ship-To BAC to continue.'
                })
            );
            setErrorType('error');
            setOpen(true);
            return;
        }

        formValidation()
        if (selectedYear.length === 0) {
            setModelYearRequired(intl.formatMessage({ id: "ordersummary.modelYearRequired", defaultMessage: "Model Year is Required" }))
        } else {
            setModelYearRequired("")
        }
        dispatch(setSearchFieldList({
            primaryFan: primaryFan,
            chargeToBac: bacNumber,
            endUserFan: endUserFan,
            modelYear: selectedYear,
            chargeToBfc: chargeBfc,
            shipToBac: shipBac
        }));
    }

    const clearForm = () => {
        setCleared(true);
        // Only clear Charge-To BAC if it's not locked (editable)
        const chargeToBacLabelElement = document.getElementById("chargeToBacGridLabel");
        const isChargeToBacLocked = chargeToBacLabelElement && chargeToBacLabelElement.style.display === 'block';
        
        if (isChargeToBacLocked) {
            // Charge-To BAC is locked (DEALER with bacFixed=true), preserve the value
            // Don't clear it
        } else if (lockChargeToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([bacNumber, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedChargeToBacs(lockedValue);
            setBacNumber(lockedValue.join(','));
        } else {
            setBacNumber("");
            setSelectedChargeToBacs([]);
        }
        // Only clear Primary FAN if it's not locked (editable)
        const primaryFanLabelElement = document.getElementById("primaryFanLabel");
        const isPrimaryFanLocked = primaryFanLabelElement && primaryFanLabelElement.style.display === 'block';
        if (!isPrimaryFanLocked) {
            setPrimaryFan("");
        }
        setEndUserFan("");
        setChargeBfc("");
        if (requiresShipToBacSelection) {
            setShipBac("");
            setSelectedShipBacs([]);
        } else if (lockShipToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([shipBac, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedShipBacs(lockedValue);
            setShipBac(lockedValue.join(','));
        } else {
            setShipBac("");
            setSelectedShipBacs([]);
        }
        setSelectedYear([]);
        setInvalidChargeToBacMessage("");
        setInvalidChargeToBfcMessage("");
        setInvalidEndUserFanMessage("");
        setInvalidPrimaryFanMessage("");
        setInvalidShipToBacMessage("");
        setStatusMessage("");
        setModelYearRequired("")
        dispatch(setOrderSummaryDataList());
        dispatch(setSearchFieldList({
            primaryFan: '',
            chargeToBac: '',
            endUserFan: '',
            modelYear: [],
            chargeToBfc: '',
            shipToBac: ''
        }));

    }

    const onChangePrimaryFan = (event) => {
        setPrimaryFan(event.target.value);
    }
    const onChangeEndUserFan = (event) => {
        setEndUserFan(event.target.value);
    }
    const onChangeChargeBfc = (event) => {
        setChargeBfc(event.target.value);
    }
    const onChangeShipBac = (event) => {
        setShipBac(event.target.value);
    }
    const onChangeShipBacSelection = (event) => {
        if (lockShipToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([shipBac, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedShipBacs(lockedValue);
            setShipBac(lockedValue.join(','));
            setInvalidShipToBacMessage('');
            return;
        }

        const {
            target: { value },
        } = event;
        const selectedValues = normalizeUniqueBacs(typeof value === 'string' ? value.split(',') : value);
        setSelectedShipBacs(selectedValues);
        setShipBac(selectedValues.join(','));
        setInvalidShipToBacMessage('');
    }
    const onChangeChargeToBac = (event) => {
        setBacNumber(event.target.value);
    }
    const onChangeChargeToBacSelection = (event) => {
        if (lockChargeToBacSelection) {
            const fallbackBac = normalizeUniqueBacs([bacNumber, userDetails?.bac])[0] || '';
            const lockedValue = fallbackBac ? [fallbackBac] : [];
            setSelectedChargeToBacs(lockedValue);
            setBacNumber(lockedValue.join(','));
            setInvalidChargeToBacMessage('');
            return;
        }

        const {
            target: { value },
        } = event;
        const selectedValues = normalizeUniqueBacs(typeof value === 'string' ? value.split(',') : value);
        
        // Handle "Select All" option
        if (selectedValues.includes('SELECT_ALL')) {
            // If all were already selected, clear all
            if (selectedChargeToBacs.length === chargeToBacOptions.length) {
                setSelectedChargeToBacs([]);
                setBacNumber('');
            } else {
                // Select all options
                setSelectedChargeToBacs(chargeToBacOptions);
                setBacNumber(chargeToBacOptions.join(','));
            }
        } else {
            setSelectedChargeToBacs(selectedValues);
            setBacNumber(selectedValues.join(','));
        }
        setInvalidChargeToBacMessage('');
    }
    const handleCheck = (e) => {
        const {
            target: { value },
        } = e;
        setSelectedYear(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };



    let styleByPartnerType;
    if (userDetails.partnerType === "FLEETDEALER") {
        styleByPartnerType = styles.orderSummaryStack_2
    } else if (userDetails.partnerType === "DEALER" || userDetails.partnerType === "UPFITTER") {
        styleByPartnerType = styles.orderSummaryStack_3
    } else if (userDetails.partnerType === "FLEET") {
        styleByPartnerType = styles.orderSummaryStack_4
    } else {
        styleByPartnerType = styles.orderSummaryStack_5
    }



    if (error === true && errorMessage !== "") {
        return (
            <ErrorAlertNotification errorMessage={errorMessage} />
        )
    } else {
        return (
            <Box sx={{ mb: '10%' }}>
                {gdlError !== "" &&
                    <ErrorAlertNotification errorMessage={gdlError} />
                }
                <Grid container sx={styles.masterMargin}>
                    <Grid size={12}>
                        <Box hidden={error === true}>
                            <OrderSummaryAppName companyName={companyName} />
                        </Box>
                    </Grid>
                    <Grid size={12}>
                        <Stack spacing={1} direction='row' sx={{ 
                            ...styleByPartnerType, 
                            ml: userDetails.partnerType === "FLEETDEALER" ? '4.5%' : '-0.5%',
                            flexWrap: 'nowrap',
                        }}>
                            <Box hidden id='chargeToBacGridLabel'>
                                <ChargeToBacLabel bacNumber={bacNumber} />
                            </Box>
                            <Box hidden id='chargeToBacGridText'>
                                <ChargeToBacText 
                                    value={bacNumber} 
                                    error={invalidChargeToBacMessage} 
                                    id='chargeToBac' 
                                    onChangeChargeToBac={onChangeChargeToBac}
                                    isFleetDealer={isFleetDealer}
                                    options={isFleetDealer && chargeToBacOptions.length >= 1 ? ['SELECT_ALL', ...chargeToBacOptions] : chargeToBacOptions}
                                    selectedValues={selectedChargeToBacs}
                                    onChangeChargeToBacSelection={onChangeChargeToBacSelection}
                                    disableSelection={lockChargeToBacSelection}
                                />
                            </Box>
                            <Box hidden id='primaryFanText'>
                                <PrimaryFanText value={primaryFan} error={invalidPrimaryFanMessage} id='primaryFan' onChangePrimaryFan={onChangePrimaryFan} />
                            </Box>
                            <Box hidden id='primaryFanLabel'>
                                <PrimaryFanLabel primaryFan={primaryFan} partnerType={userDetails.partnerType} />
                            </Box>

                            <Box hidden id='endUserFanGrid'>
                                <EndUserFan value={endUserFan} error={invalidEndUserFanMessage} id='endUserFan' onChangeEndUserFan={onChangeEndUserFan} />
                            </Box>
                            <Box hidden={error === true} id='modelYearDropdown' sx={{ flex: '1 1 280px', minWidth: '180px' }}>
                                <ModelYear modelYearRequired={modelYearRequired} selectedYear={selectedYear} options={modelYear} handleCheck={handleCheck} />
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid size={12}>       
                        <Stack spacing={1} direction='row' sx={{ 
                            ...styleByPartnerType,
                            '& > *': {
                                flex: '0.2 1 100px',
                                minWidth: '220px',
                            }
                        }}>
                            <Box hidden={error === true}>
                                <ChargeToBfc value={chargeBfc} error={invalidChargeToBfcMessage} id='chargeBfc' onChangeChargeBfc={onChangeChargeBfc} />
                            </Box>
                            <Box hidden id='shipToBacLabel'>
                                <ShipToBacLabel bacNumber={shipBac} noChildBacs={lockShipToBacSelection} />
                            </Box>
                            <Box hidden id='shipToBacText'>
                                <ShipToBac
                                    value={shipBac}
                                    error={invalidShipToBacMessage}
                                    id='shipBac'
                                    onChangeShipBac={onChangeShipBac}
                                    isUpfitter={String(userDetails?.partnerType || '').toUpperCase() === 'UPFITTER'}
                                    options={shipToBacOptions}
                                    selectedValues={selectedShipBacs}
                                    onChangeShipBacSelection={onChangeShipBacSelection}
                                    disableSelection={lockShipToBacSelection}
                                />
                            </Box>
                        </Stack>
                    </Grid>

                    <Grid size={12} hidden={error === true}>
                        <Stack direction='row' spacing={2} sx={styles.orderSummaryStackButton}>
                            <ClearButton clearForm={clearForm} />
                            <SearchButton
                                statusMessage={statusMessage}
                                invalidChargeToBacMessage={invalidChargeToBacMessage}
                                invalidChargeToBfcMessage={invalidChargeToBfcMessage}
                                invalidEndUserFanMessage={invalidEndUserFanMessage}
                                invalidPrimaryFanMessage={invalidPrimaryFanMessage}
                                invalidShipToBacMessage={invalidShipToBacMessage}
                                errorType={errorType}
                                loading={loading}
                                open={open} handleClose={handleClose} submitHandler={SubmitHandler} />
                        </Stack>
                    </Grid>
                    {dataListItem !== null && dataListItem !== undefined &&

                        <Grid size={12}>
                            <Box>
                                <OrderSummaryTable
                                    chargeToBac={bacNumber}
                                    primaryFleetAccountNumber={primaryFan}
                                    partnerType={userDetails.partnerType}
                                    endUserFleetAccountNumber={endUserFan}
                                    chargeToBfc={chargeBfc}
                                    shipToBac={shipBac}
                                    modelYear={selectedYear}
                                />
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Box >
        )
    }
}
